import {
  TournamentCard,
  TournamentCardProps,
} from '@pickleballinc/ui/components/global/Cards/TournamentCard';
import { useSession } from '@pickleballinc/ui/components/global/SessionProvider';
import { useState } from 'react';

import { FavoriteButton } from '@/modules/players/v2/tabs/components/FavoriteButton';

interface FavoriteTournamentCardProps extends TournamentCardProps {
  moduleUuid: string;
  shouldHideFavoriteButton?: boolean;
  onRefetch?: () => void;
}

export const FavoriteTournamentCard = ({
  moduleUuid,
  shouldHideFavoriteButton,
  onRefetch,
  ...tournamentProps
}: FavoriteTournamentCardProps) => {
  const [isFavorited, setIsFavorited] = useState(tournamentProps.isFavorite || false);
  const { session } = useSession();

  return (
    <div className='relative h-full sm:h-auto min-[500px]:min-w-[224px] min-[500px]:max-w-[286px] mt-auto'>
      {session?.user?.uuid && !shouldHideFavoriteButton ? (
        <div className='absolute right-2 top-2 z-10'>
          <FavoriteButton
            moduleUuid={moduleUuid}
            isFavorited={isFavorited}
            setIsFavorited={setIsFavorited}
            onSuccessToggle={onRefetch}
          />
        </div>
      ) : null}
      <TournamentCard {...tournamentProps} />
    </div>
  );
};
